/* Vendor imports */
import React from 'react'
import PropTypes from 'prop-types'
/* App imports */
import Header from './header'
import Footer from './footer'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { Container, Title } from '../style/components/layout'
import theme from '../style/theme'
import { heading, modifySize } from '../style/mixins'
import fonts from '../style/fonts'

const GlobalStyle = createGlobalStyle`

@font-face {
    font-family: "CustomFont";
    font-weight: normal;
    src: local("CustomFont"), url(${fonts.NunitoRegular}) format("truetype");
  }

  @font-face {
    font-family: "CustomFont";
    font-weight: bold;
    src: local("CustomFont"), url(${fonts.MontserratBold}) format("truetype");
  }

  @font-face {
    font-family: "CustomBoldFont";
    font-weight: bold;
    src: local("CustomBoldFont"), url(${fonts.NunitoBold}) format("truetype");
  }

  @font-face {
    font-family: "Roboto-Mono";
    font-weight: normal;
    src: local("Roboto-Mono"), url(${
      fonts.RobotoMonoRegular
    }) format("truetype");
  } 



 
  /* Body */

  body {
      font-family: "CustomFont", sans-serif;
      font-size: ${modifySize(theme['font-size'], 1.2)};
      background-color: ${theme['theme-color']};
      background-image: ${theme['texture']};
      color: ${theme['main-color']};
      margin: ${theme['margin-zero']};
  }

  /* Headings */
  h1 {
    ${heading({ theme }, modifySize(theme['font-size'], 2))}
  }

  h2 {
    ${heading({ theme }, modifySize(theme['font-size'], 1.75))}
  }

  h3 {
    ${heading({ theme }, modifySize(theme['font-size'], 1.5))}
  }

  h4{
    ${heading({ theme }, modifySize(theme['font-size'], 1.25))}
  }

  /* Links */

  h1, h2, h3, h4, h5, h6 {
      a {
          text-decoration: none;
          color: inherit;
      }
  }

  a {
      text-decoration: none;
      color: inherit;
  }

`

const Layout = ({ children, title }) => (
  <>
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <GlobalStyle />
        <Header />
        <Container>
          {title ? (
            <Title>
              <h1>{title}</h1>
            </Title>
          ) : null}
          {children}
        </Container>
        <Footer />
      </React.Fragment>
    </ThemeProvider>
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
}

Layout.defaultProps = {
  title: '',
}

export default Layout
